export default __webpack_public_path__ + "static/1-0ff4189a9a8a49f1f085e583e81e0be6.jpeg";